import { ISalesService } from '../@types/services';
import { createApi } from '../providers/factories';
import salesService from './salesService';

const createSalesService = (): ISalesService => {
  const apiProvider = createApi();
  return salesService(apiProvider);
}

export default createSalesService;
